/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */
import { FlexRow, FlexCol, ContentContainerBodyShift, Heading, Text } from 'sarsaparilla';

export default function FindingTree() {
    return (
        <section
            className="tree-permit-finding-container"
            aria-labelledby="tree-permit-finding-heading"
        >
            <ContentContainerBodyShift>
                <FlexRow>
                    <FlexCol
                        xs={12}
                        lg={5}
                        className="tree-permit-finding-heading mb-2 mb-lg-0"
                    >
                        <Heading
                            headingLevel={2}
                            appearance="h3"
                            id="tree-permit-finding-heading"
                        >
                            A holiday tradition that gives back to the forest
                        </Heading>
                    </FlexCol>
                    <FlexCol xs={12} lg={7} className="tree-permit-finding-copy">
                        <Text color="gray" size="lg" className="mb-2">
                            A memorable experience, cutting a Christmas tree is a special
                            tradition to share with family and friends while helping to
                            maintain a healthy forest. For many families, venturing into
                            the forest to cut a Christmas tree for the holidays is a
                            treasured tradition carried on for generations, while others
                            may just be discovering the thrill of searching for the
                            perfect holiday centerpiece.
                        </Text>
                        <Text color="gray" size="lg">
                            For every tree that is found, cut and carried home as a
                            holiday fixture, you&apos;re also contributing to the overall
                            forest health. Christmas tree permits are a unique opportunity
                            to help thin densely populated stands of small-diameter trees
                            - the perfect size for a Christmas tree.
                        </Text>
                    </FlexCol>
                </FlexRow>
            </ContentContainerBodyShift>
        </section>
    );
}
